import React from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import animationData from "../../Assets/Animations/home.json"; // Adjust path as needed

const LottiePlayer = () => (
  <Player
    autoplay
    loop
    src={animationData} // Use the imported JSON here
    style={{ height: "600px", width: "600px" }}
  />
);

export default LottiePlayer;
